import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { API_ROUTE_FEATURE_FLAGS, getApiUrl } from '../../app.constants';
import { Observable } from 'rxjs';
import { FeatureFlag } from '../../model/feature-flag.model';
import { createFeatureFlagStatusResolver } from '@shared-ikp/service/feature-flag/feature-flag.utils';
import { FeatureFlagResponse } from '@shared-ikp/model/feature-flag.model';

/**
 * Service to fetch feature flag status. Feature flag status is cached in memory as long as the service exists.
 */
@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService extends ApiService {
  private readonly resolveFeatureFlagStatus = createFeatureFlagStatusResolver((title: string) => {
    const url = `${getApiUrl(this.apiUrl, API_ROUTE_FEATURE_FLAGS)}/enabled/${title}`;
    return this.httpClient.get<FeatureFlagResponse>(url);
  });

  getFeatureFlagStatus(title: FeatureFlag): Observable<boolean> {
    return this.resolveFeatureFlagStatus(title);
  }
}
